module.exports = __webpack_public_path__ + "img/34.cab02ae.png";